<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/dashboard">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ GlobalVar.title }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/dashboard">
        <!--<img v-if="logo" :src="logo" class="sidebar-logo">-->
        <!--<h1 class="sidebar-title">{{ GlobalVar.title }} </h1>-->
        <img src="@/assets/white-logo.png" style="width:157px;height: 51px;"/>
      </router-link>
    </transition>
  </div>
</template>

<script>
import Logo from '@/assets/logo.png'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      logo: Logo
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  /*height: 50px;*/
  /*line-height: 50px;*/
  height: 110px;
  line-height: 110px;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    padding:30px 20px;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 6px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0;
    }
    .sidebar-logo-link{padding:0}
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue